var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"user-center",attrs:{"src":require("../../assets/img-v2/ic_mine.png"),"alt":"个人中心"},on:{"click":_vm.onUserTriggerClick}})}
var staticRenderFns = []

export { render, staticRenderFns }